<template>
  <a href="#main" class="skip-link" @click.prevent="skipToMain">Skip to main content</a>
  <headerComponent/>
  <main id="main" tabindex="-1">
    <router-view/>
  </main>
  <footerComponent/>
</template>

<script>
import headerComponent from './components/header-footer/header.vue'
import footerComponent from './components/header-footer/footer.vue'

export default {
  components:{
    headerComponent,
    footerComponent
  },
  methods: {
    skipToMain() {
      document.getElementById('main').focus()
    }
  }
}
</script>

<style>

h1,h2,h3,h4,h5,h6{
  font-family: 'Playfair Display', serif;
}
.h1,.h2,.h3,.h4,.h5,.h6{
  font-family: 'Playfair Display', serif;
}
p{
  font-family: Arial, Helvetica, sans-serif
}

.bg-danger, .btn-danger{
  background: rgb(95, 1, 1);
  border: 1px solid black;
}
.btn-danger:hover{
  background: rgb(70, 1, 1) !important;
}
.text-danger{
  color: rgb(95, 1, 1) !important;
}

/* Hidden until a keyboard user tabs to it */
.skip-link{
  position: absolute;
  top: -100px;
  left: 1rem;
  z-index: 3000;
  padding: .75rem 1.25rem;
  background: #fff;
  color: #000;
  font-weight: bold;
  border-radius: 0 0 .375rem .375rem;
}
.skip-link:focus{
  top: 0;
}
#main:focus{
  outline: none;
}
/* Pages load on demand; reserving the screen keeps the footer from jumping when they arrive */
#main{
  min-height: 100vh;
}
</style>
